"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOverrides = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var selectOverrides = {
  MuiSelect: {
    styleOverrides: {
      select: function select(_ref) {
        var spacing = _ref.theme.spacing;
        return {
          // .MuiSelect-select
          '&.MuiInputBase-input': {
            paddingRight: spacing(7),
            '&:focus': {
              background: 'transparent'
            }
          }
        };
      },
      icon: function icon(_ref2) {
        var spacing = _ref2.theme.spacing;
        return {
          // .MuiSelect-icon
          right: spacing(2)
        };
      },
      iconOpen: {
        // .MuiSelect-iconOpen
        transform: 'rotate(-180deg)'
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      paper: function paper(_ref3) {
        var spacing = _ref3.theme.spacing;
        return {
          // .MuiMenu-paper
          marginTop: spacing(0.5),
          '&.MuiMenu-paper': {
            maxHeight: '285px'
          }
        };
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: function root(_ref4) {
        var _ref4$theme = _ref4.theme,
          palette = _ref4$theme.palette,
          shape = _ref4$theme.shape,
          spacing = _ref4$theme.spacing,
          typography = _ref4$theme.typography;
        return _objectSpread(_objectSpread({}, typography.bodyLarge), {}, {
          minHeight: 0,
          color: palette.common.black,
          borderRadius: shape.borderRadius,
          boxShadow: "inset 0px 0px 0px 1px ".concat(palette.grey['400']),
          margin: "".concat(spacing(1), " ").concat(spacing(2)),
          padding: "".concat(spacing(1), " ").concat(spacing(2)),
          '&:hover': {
            background: palette.grey['50']
          },
          '&.Mui-selected': _objectSpread(_objectSpread({}, typography.actionBold), {}, {
            background: 'transparent',
            '&.Mui-focusVisible': {
              background: 'transparent'
            },
            '&:hover': {
              background: palette.grey['50']
            }
          }),
          '&.Mui-focusVisible': {
            background: 'transparent'
          },
          '&.Mui-selected, &.Mui-focusVisible': {
            color: palette.grey['600'],
            boxShadow: "inset 0px 0px 0px 2px ".concat(palette.common.black)
          }
        });
      }
    }
  }
};
exports.selectOverrides = selectOverrides;